import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const actionClass = "flex items-center gap-2 text-primary font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300";

const services = [
  {
    icon: "🦷",
    title: "Root Canal Treatment",
    subtitle: "Pain-Free",
    description:
      "Advanced rotary endodontics for long-lasting relief and tooth preservation.",
    href: "/services/root-canal-treatment",
  },
  {
    icon: "🔩",
    title: "Dental Implants",
    subtitle: "Permanent Solution",
    description:
      "Natural-looking tooth replacements with precision planning.",
  },
  {
    icon: "✨",
    title: "Cosmetic Dentistry",
    subtitle: "Smile Design",
    description:
      "Smile designing, teeth whitening, veneers & aesthetic corrections.",
  },
  {
    icon: "😁",
    title: "Braces & Aligners",
    subtitle: "Orthodontics",
    description:
      "Modern orthodontic solutions for children, teens & adults.",
  },
  {
    icon: "👶",
    title: "Kids & Family Dentistry",
    subtitle: "All Ages",
    description:
      "Gentle, safe and friendly dental care for all age groups.",
  },
  {
    icon: "🏥",
    title: "Complete Oral Care",
    subtitle: "Full Service",
    description:
      "From routine checkups to advanced procedures — all under one roof.",
  },
];

export const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-4">
            Our Expertise
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Comprehensive Dental Services
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            From routine checkups to advanced procedures, our MDS specialists deliver 
            exceptional care using evidence-based clinical protocols.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="group relative bg-card rounded-2xl p-6 shadow-soft hover:shadow-card transition-all duration-300 border border-border/50 overflow-hidden cursor-pointer"
            >
              {/* Hover gradient overlay */}
              <div className="absolute inset-0 gradient-primary opacity-0 group-hover:opacity-5 transition-opacity duration-300" />
              
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center text-3xl group-hover:scale-110 transition-transform duration-300">
                    {service.icon}
                  </div>
                  <span className="text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">
                    {service.subtitle}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                  {service.title}
                </h3>
                <p className="text-muted-foreground mb-4">{service.description}</p>
                {service.href ? (
                  <Link to={service.href} className={actionClass}>
                    <span>Learn more</span>
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                ) : (
                  <div className={actionClass}>
                    <span>Learn more</span>
                    <ArrowRight className="w-4 h-4" />
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
